// @flow
import AddBalanceLoader from './AddBalanceLoader'
export default AddBalanceLoader
